import { IMAGES, SITE } from "@/config/site";
import { Reveal } from "@/components/Reveal";

const VALUES = ["Ascolto", "Competenza", "Territorio"];

export default function About() {
  return (
    <section id="chi-siamo" className="section-pad scroll-mt-20 bg-[#f3efea]" data-testid="about-section">
      <div className="container-x grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <Reveal>
            <span className="eyebrow">
              <span className="text-[#0050e0]/60">05</span> Chi siamo
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h-display mt-4 text-3xl leading-[1.08] sm:text-4xl lg:text-5xl">
              Una parafarmacia pensata intorno alle persone.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-[#575a61] sm:text-lg">
              Farma Store nasce con un&rsquo;idea semplice: unire una selezione accurata di prodotti a un consiglio
              professionale e realmente personale. Un luogo dove sentirsi ascoltati e trovare risposte, non
              semplicemente scaffali.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <ul className="mt-8 flex flex-wrap gap-2.5">
              {VALUES.map((v) => (
                <li
                  key={v}
                  className="font-display rounded-full border border-black/10 bg-white px-4 py-2 text-sm font-bold text-[#1c1d1f]"
                >
                  {v}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-8 flex items-center gap-2 text-sm font-medium text-[#888c95]">
              <span aria-hidden="true" className="h-px w-8 bg-[#0050e0]/40" />
              {SITE.address}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem]">
            <img src={IMAGES.about.src} alt={IMAGES.about.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover object-[50%_12%]" />
            <div aria-hidden="true" className="absolute inset-0 rounded-[2rem] ring-1 ring-inset ring-black/10" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
